
define('template!webshopAttributesFieldsPickerView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="toolbar">\n    <input type="text" class="search" placeholder="' +
((__t = ( _.i18n('attributeMatching.searchField', null, 'Code or name of the supplier field') )) == null ? '' : __t) +
'"/>\n    <select class="supplier">\n        <option value="">' +
((__t = ( _.i18n('attributeMatching.allSuppliers', null, 'All suppliers') )) == null ? '' : __t) +
'</option>\n        ';
 _.each(suppliers, function (s) { ;
__p += '<option value="' +
__e( s ) +
'">' +
__e( s ) +
'</option>';
 }); ;
__p += '\n    </select>\n    <label><input type="checkbox" class="unmatched" checked/> ' +
((__t = ( _.i18n('attributeMatching.onlyUnmatched', null, 'Only unmatched') )) == null ? '' : __t) +
'</label>\n</div>\n<div class="list"></div>\n<div class="footer">\n    <div class="pager"></div>\n    <span class="apply">' +
((__t = ( _.i18n('attributeMatching.matchSelected', null, 'Match the selected fields to') )) == null ? '' : __t) +
' <b>' +
__e( keyName ) +
'</b> (<span class="selected-count">0</span>)</span>\n</div>\n';

}
return __p
};});

